<template>
    <div :class="{ 'container container-xs': hideSocials }">
        <div class="row d-lg-flex d-md-flex d-sm-block d-block">
            <div class="col-sm-12 col-12 pr-md-5" :class="{ 'col-lg-6 col-md-6 border-right': !hideSocials }">
                <Username v-model="username" :title="$t('label_email')" @keyup.enter="login()"
                    :errorMsg="errorMsgs.username" @input="updateUsername($event)"></Username>
                <div class="form-group">
                    <div class="d-flex justify-content-between align-items-center">
                        <label for="passwordLogin">{{ $t('label_password') }}</label>
                        <router-link class="link p-0" :to="{ name: 'reset-password' }">{{ $t('btn_reset_password')
                        }}</router-link>
                    </div>
                    <span class="invalid-feedback">
                        {{ errorMsgs.password }}
                    </span>
                    <input type="password" class="w-100" v-model="password" @keyup.enter="login()"
                        v-bind:class="{ 'has-error': errorMsgs.password }">
                </div>
                <div class="col-md-6 p-0 col-sm-12">
                    <div class="action-button text-center">
                        <van-button dusk="login-button" block :loading="loading" @click="login()" class="main-btn" square>{{
                            $t('btn_login') }}</van-button>
                    </div>
                </div>
                <div class="mt-4 d-flex justify-content-between cont-nou">
                    <span>{{ $t('login_component_no_account') }} <router-link class="link" :to="{ name: 'new-account' }">{{
                        $t('new_account_title') }}</router-link></span>
                </div>
                <div class="or grey d-flex align-items-end d-sm-block d-md-none">
                    <span>{{ $t('or') }}</span>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 pl-md-5 pt-md-4" v-if="!hideSocials">
                <button :loading="loadingGoogle" @click="loginGoogle()" class="google-login-btn">
                    <span>
                        {{ $t('continue_with') }} Google
                    </span>
                </button>
                <button :loading="loadingFacebook" @click="loginFacebook()" class="facebook-login-btn">
                    <span>
                        {{ $t('continue_with') }} Facebook
                    </span>
                </button>
                <template v-if="['ios', 'desktop'].includes(os())">
                    <button :loading="loadingApple" @click="loginApple()" class="apple-login-btn">
                        <span>
                            {{ $t('continue_with') }} Apple
                        </span>
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import auth3rdp from '../mixins/auth3rdp.js'
import Username from './../snippets/Username.vue'

export default {
    name: 'LoginComponent',
    props: {
        hideSocials: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Username
    },
    mixins: [
        auth3rdp
    ],
    data: function () {
        return {
            username: '',
            password: '',
            errorMsgs: {
                username: '',
                password: '',
            },

            usernames: [],
            usernameChoosen: false,

            loading: false,
        }
    },
    methods: {
        ...mapActions('vehicles', [
            'getVehicles'
        ]),

        ...mapActions('auth', [
            'doLogin',
            'doGetUsersForEmail'
        ]),

    
        updateUsername(event) {
            this.username = event.value;
        },

        async login() {
            var ok = true;
            this.loading = true;

            if (!this.username) {
                ok = false;
                this.errorMsgs.username = this.$t('mandatory');
            }

            if (!this.password) {
                ok = false;
                this.errorMsgs.password = this.$t('mandatory');
            }

            if (ok) {

                try {
                    await this.doLogin({ username: this.username, password: this.password });
                    this.redirectAfterLogin();
                }
                catch (err) {
                    this.loading = false;

                    if (err.response) {
                        this.$dialog.alert({
                            'message': err.response.data.error,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                }
            }
            else {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.signin-button {
    width: 100%;
    height: 40px;
    margin-top: 40px;
    border: 2px solid #0F2443;
    border-radius: 4px;
}

input {
    border: 1px solid #C7C7C6;
    border-radius: 4px;
    padding: 10px 20px;
    height: 50px;
    margin-bottom: 30px;
    font-weight: 500;
}

label {
    font-weight: 500;
    margin-bottom: 0px;
}

.link {
    font-size: 14px;
}

.border-right {
    @media only screen and (min-width: 768px) {
        border-right: 1px solid #C7C7C6 !important;
    }

    @media only screen and (max-width: 767px) {
        border-right: 0px !important;
    }
}

.cont-nou {
    font-size: 18px;

    a {
        font-weight: bold;
        font-size: 18px;
    }
}

.wrapper:first-of-type {
    padding-top: 0px;
}

.wrapper {
    width: calc(50% - 2px);
    min-width: 500px;
    padding: 40px 66.5px 0 66.5px;
}

.intra-in-cont {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
}

.google-login-btn {
    margin-bottom: 40px;
    margin-top: 13px;
}

.apple-login-btn {
    margin-top: 40px;
}

.or {
    color: #737880;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
}

.google-icon,
.facebook-icon {
    margin-right: 35px;
}

@media only screen and (max-width: 600px) {

    .google-login-btn,
    .facebook-login-btn {
        min-width: 100%;
    }
}

@media only screen and (max-width: 320px) {

    .google-icon,
    .facebook-icon {
        margin-right: 10px;
    }
}</style>
